/**
 * Mixpanel sink (EU data residency, project per app). Plain HTTP ingestion —
 * no SDK, no cookies, no autocapture, no IP geolocation (`ip=0`) — so the
 * privacy promise holds and the "Help improve" switch silences it exactly like
 * the GA4 mirror. The token is a public client-side value. Fire-and-forget.
 * Replaces the first-party Firestore `events` sink (Rhett, 7 Sep 2026).
 */
// `time` is SECONDS since epoch for /track (milliseconds file the event millennia ahead and it never shows in reports).
const TRACK_URL = 'https://api-eu.mixpanel.com/track?ip=0';

export function sendMixpanel(token: string, event: string, distinctId: string, props: Record<string, string | number | boolean>): void {
  if (!token || typeof fetch !== 'function') return;
  const body = [{ event, properties: { token, distinct_id: distinctId, time: Math.floor(Date.now() / 1000), $insert_id: insertId(), ...props } }];
  try {
    // Form-encoded `data=` (what Mixpanel's own SDK sends): a CORS "simple request", so the
    // browser never preflights. A JSON content type is refused at preflight and nothing is sent
    // (found 7 Sep 2026: Node probes passed, browsers silently dropped every event).
    void fetch(TRACK_URL, { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, body: 'data=' + encodeURIComponent(JSON.stringify(body)), keepalive: true }).catch(() => undefined);
  } catch {
    /* never throws */
  }
}

function insertId(): string {
  try {
    return crypto.randomUUID();
  } catch {
    return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
  }
}
